export const AUTH_REDUCER_NAME = 'auth'
export const USER_REDUCER_NAME = 'user'
export const PASS_INIT_RESET_REDUCER_NAME = 'passInitReset'
